module.exports = __webpack_public_path__ + "static/media/CBNImg8.cf76bc74.webp";